export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-950 via-foreground-900 to-primary-950"></div>
      <div className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Dramatic%20abstract%20artistic%20composition%20representing%20entertainment%20news%20and%20media%20culture%2C%20warm%20crimson%20and%20dark%20amber%20gradient%20tones%2C%20stylized%20geometric%20shapes%20and%20light%20streaks%2C%20cinematic%20atmosphere%20with%20subtle%20grain%20texture%2C%20editorial%20photojournalism%20aesthetic%2C%20mysterious%20and%20dramatic%20mood%2C%20high%20contrast%20composition%20with%20deep%20shadows&width=1600&height=900&seq=hero-bg-2026&orientation=landscape)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
              <i className="ri-flashlight-line text-primary-400 text-sm"></i>
              <span className="text-primary-300 text-xs font-medium tracking-wide">实时追踪 · 深度爆料</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
              吃瓜黑料爆料
              <span className="block text-primary-400 text-xl md:text-2xl lg:text-3xl font-semibold mt-2">
                娱乐圈内幕深度追踪平台
              </span>
            </h1>

            <p className="text-accent-300/90 text-lg md:text-xl font-medium mb-4">
              一手黑料，全网最快
            </p>

            <p className="text-background-300/80 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              17c吃瓜黑料爆料专注明星出轨内幕与娱乐圈丑闻细节的深度追踪。我们汇聚全网最新八卦事件，提供从时间线梳理到黑料证据整理的一站式解析服务。无论是最新爆出的婚变传闻，还是沉淀多年的圈内秘辛，这里都有你想要的真相碎片——每日更新，永不缺瓜。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
                <span className="text-background-200/70 text-xs md:text-sm">日均更新 50+ 条爆料</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
                <span className="text-background-200/70 text-xs md:text-sm">覆盖 200+ 位艺人动态</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
                <span className="text-background-200/70 text-xs md:text-sm">全天候 7×24 追踪</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                onClick={(e) => handleNavClick(e, '#topics')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-colors text-center whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line mr-2"></i>立即吃瓜
              </a>
              <a
                href="#contact"
                onClick={(e) => handleNavClick(e, '#contact')}
                className="w-full sm:w-auto px-8 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/30 font-medium rounded-lg transition-colors text-center whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-send-plane-line mr-2"></i>我要爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/5] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20artistic%20editorial%20composition%20with%20abstract%20newspaper%20fragments%20floating%20in%20warm%20crimson%20light%2C%20dark%20theatrical%20atmosphere%20with%20spotlight%20effects%2C%20motion%20blur%20and%20dynamic%20energy%2C%20celebrity%20silhouette%20in%20dramatic%20backlighting%2C%20magazine%20cover%20aesthetic%2C%20bold%20contrast%2C%20editorial%20photography%20style%2C%20mysterious%20and%20captivating%20mood&width=800&height=1000&seq=hero-main-2026&orientation=portrait"
                alt="吃瓜黑料爆料 - 娱乐圈内幕深度追踪平台主视觉"
                className="w-full h-full object-cover rounded-xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent rounded-xl"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-2 text-background-50/90 text-xs">
                  <span className="px-2 py-1 bg-primary-500/80 rounded text-[10px] font-semibold whitespace-nowrap">独家</span>
                  <span className="whitespace-nowrap">内幕追踪 · 深度解析</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}